/**
 * @file biz/listPage/BulkArea
 * @author chenbo09
 * @modify zhangzhe
 */

import React from 'react';
import {Button, Checkbox} from 'acud';

import {DU_PREFIX} from '../../_common/constants';
import {BulkItem} from './index';

import {useLocale} from '../../../components/locale';

import './index.less';

const CLS_PREFIX = `${DU_PREFIX}-bulk`;

export interface BulkAreaProps {
    position?: string;
    loading?: boolean;
    selectedRowKeys?: any[];
    checkedAll?: boolean;
    bulkComp?: React.ComponentType<any>;
    bulkConfig?: BulkItem[];
    onHandleAction: (config: any, payload?: any) => void;
}

const BulkArea: React.FunctionComponent<BulkAreaProps> = props => {
    const {
        position = 'left', // 当前组件的位置
        loading,
        onHandleAction,
        selectedRowKeys,
        checkedAll,
        bulkComp,
        bulkConfig
    } = props;
    const hasSelected = selectedRowKeys && selectedRowKeys.length > 0;
    const Bulk = bulkComp;

    const [locale] = useLocale('HooksList');

    const renderButton = (item: BulkItem, disabled = false) => (
        <Button
            className={`${CLS_PREFIX}-button`}
            key={item.id}
            {...(item.skin !== 'danger' ? {type: item.skin} : {danger: true})}
            icon={item.icon}
            disabled={disabled}
            onClick={() => onHandleAction(item)}
            // loading={item.id === 'refresh' && loading} // zhangzhe 2019-04-29 按钮一律不显示loading状态
        >
            {item.text}
        </Button>
    );
    const renderCheckbox = (item: BulkItem) => (
        <Checkbox
            className={`${CLS_PREFIX}-checkbox`}
            key={item.id}
            checked={checkedAll}
            onChange={e => onHandleAction(item, {checked: e.target.checked})}
        >
            {item.text}
        </Checkbox>
    );

    if (Bulk) {
        return (
            <Bulk
                loading={loading}
                handleAction={onHandleAction}
                selectedRowKeys={selectedRowKeys}
                hasSelected={hasSelected}
            />
        );
    }
    else if (bulkConfig && bulkConfig.length) {
        return (
            <div className={CLS_PREFIX}>
                {bulkConfig.map(item => {
                    // 默认位置在左边
                    item.position = item.position || 'left';
                    // 是否可点击
                    const disabled = item.disabled || (item.select && !hasSelected);
                    if (item.position === position) {
                        return item.type === 'checkbox'
                            ? renderCheckbox(item)
                            : renderButton(item, disabled);
                    }
                    return null;
                })}
                {position === 'left' && selectedRowKeys && (
                    <span className={`${CLS_PREFIX}-selected-count`}>
                        {hasSelected ? `${locale?.chosen}${selectedRowKeys.length}${locale?.Record}` : ''}
                    </span>
                )}
            </div>
        );
    }
    return null;
};

BulkArea.defaultProps = {
    position: 'left',
    loading: false
};

export default BulkArea;
